export const sizeChartData = {
    columns: [
        {
            title: "Pending Units",
            children: [
                {
                    title: "T-Jacket",
                    dataIndex: "stage",
                    key: "stage",
                    width: 75,
                    children: [
                        {
                            title: "Shirt",
                            dataIndex: "stage",
                            key: "stage",
                            width: 75,
                            children: [
                                {
                                    title: "Y-Adult",
                                    dataIndex: "stage",
                                    key: "stage",
                                    width: 75,
                                    children: [
                                        {
                                            title: "W-Plus",
                                            dataIndex: "stage",
                                            key: "stage",
                                            width: 75,
                                            children: [
                                                {
                                                    title: "Kids",
                                                    dataIndex: "stage",
                                                    key: "stage",
                                                    width: 75,
                                                    children: [
                                                        {
                                                            title: "Men",
                                                            dataIndex: "stage",
                                                            key: "stage",
                                                            width: 75,
                                                            children: [
                                                                {
                                                                    title: "Women",
                                                                    dataIndex: "stage",
                                                                    key: "stage",
                                                                    width: 80,
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: '"2/3"',
                    align: "right",
                    dataIndex: "qty_1",
                    key: "qty_1",
                    width: 40,
                    children: [
                        {
                            title: "XS",
                            dataIndex: "qty_1",
                            key: "qty_1",
                            width: 40,
                            align: "right",

                            children: [
                                {
                                    title: "00",
                                    dataIndex: "qty_1",
                                    key: "qty_1",
                                    width: 40,
                                    align: "right",
                                    children: [
                                        {
                                            title: "10W",
                                            dataIndex: "qty_1",
                                            key: "qty_1",
                                            width: 40,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "2",
                                                    dataIndex: "qty_1",
                                                    key: "qty_1",
                                                    width: 40,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "27",
                                                            dataIndex: "qty_1",
                                                            key: "qty_1",
                                                            align: "right",
                                                            width: 40,
                                                            children: [
                                                                {
                                                                    title: "23",
                                                                    dataIndex: "qty_1",
                                                                    key: "qty_1",
                                                                    width: 40,
                                                                    align: "right",
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: '"4/5"',
                    align: "right",
                    dataIndex: "qty_2",
                    key: "qty_2",
                    width: 50,
                    children: [
                        {
                            title: "S",
                            align: "right",
                            dataIndex: "qty_2",
                            key: "qty_2",
                            width: 55,

                            children: [
                                {
                                    title: "0",
                                    align: "right",
                                    dataIndex: "qty_2",
                                    key: "qty_2",
                                    width: 55,
                                    children: [
                                        {
                                            title: "12W",
                                            align: "right",
                                            dataIndex: "qty_2",
                                            key: "qty_2",
                                            width: 55,
                                            children: [
                                                {
                                                    title: "3",
                                                    align: "right",
                                                    dataIndex: "qty_2",
                                                    key: "qty_2",
                                                    width: 50,
                                                    children: [
                                                        {
                                                            title: "28",
                                                            align: "right",
                                                            dataIndex: "qty_2",
                                                            key: "qty_2",
                                                            width: 50,
                                                            children: [
                                                                {
                                                                    title: "24",
                                                                    align: "right",
                                                                    dataIndex: "qty_2",
                                                                    key: "qty_2",
                                                                    width: 40,
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: '"6/6X"',
                    dataIndex: "qty_3",
                    key: "qty_3",
                    align: "right",
                    width: 60,
                    children: [
                        {
                            title: "M",
                            dataIndex: "qty_3",
                            key: "qty_3",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "1",
                                    dataIndex: "qty_3",
                                    key: "qty_3",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "14W",
                                            dataIndex: "qty_3",
                                            key: "qty_3",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "4",
                                                    dataIndex: "qty_3",
                                                    key: "qty_3",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "29",
                                                            dataIndex: "qty_3",
                                                            key: "qty_3",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "25",
                                                                    dataIndex: "qty_3",
                                                                    key: "qty_3",
                                                                    width: 45,
                                                                    align: "right",
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],

                        }
                    ]
                },
                {
                    title: '"7/8"',
                    dataIndex: "qty_4",
                    key: "qty_4",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "L",
                            dataIndex: "qty_4",
                            key: "qty_4",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "2",
                                    dataIndex: "qty_4",
                                    key: "qty_4",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "16W",
                                            dataIndex: "qty_4",
                                            key: "qty_4",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "5",
                                                    dataIndex: "qty_4",
                                                    key: "qty_4",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "30",
                                                            dataIndex: "qty_4",
                                                            key: "qty_4",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "26",
                                                                    dataIndex: "qty_4",
                                                                    key: "qty_4",
                                                                    width: 40,
                                                                    align: "right",
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: '"9/10"',
                    dataIndex: "qty_5",
                    key: "qty_5",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "XL",
                            dataIndex: "qty_5",
                            key: "qty_5",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "3",
                                    dataIndex: "qty_5",
                                    key: "qty_5",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "18W",
                                            dataIndex: "qty_5",
                                            key: "qty_5",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "6",
                                                    dataIndex: "qty_5",
                                                    key: "qty_5",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "31",
                                                            dataIndex: "qty_5",
                                                            key: "qty_5",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "27",
                                                                    dataIndex: "qty_5",
                                                                    key: "qty_5",
                                                                    width: 40,
                                                                    align: "right",
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: '"11/12"',
                    dataIndex: "qty_6",
                    key: "qty_6",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "XXL / 1XL",
                            dataIndex: "qty_6",
                            key: "qty_6",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "4",
                                    dataIndex: "qty_6",
                                    key: "qty_6",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "20W",
                                            dataIndex: "qty_6",
                                            key: "qty_6",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "6x",
                                                    dataIndex: "qty_6",
                                                    key: "qty_6",
                                                    width: 50,
                                                    align: "right",

                                                    children: [
                                                        {
                                                            title: "32",
                                                            dataIndex: "qty_6",
                                                            key: "qty_6",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "28",
                                                                    dataIndex: "qty_6",
                                                                    key: "qty_6",
                                                                    width: 40,
                                                                    align: "right",
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],

                        }
                    ]
                },
                {
                    title: '"13/14"',
                    dataIndex: "qty_7",
                    key: "qty_7",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "2XL",
                            dataIndex: "qty_7",
                            key: "qty_7",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "5",
                                    dataIndex: "qty_7",
                                    key: "qty_7",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "22W",
                                            dataIndex: "qty_7",
                                            key: "qty_7",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "7",
                                                    dataIndex: "qty_7",
                                                    key: "qty_7",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "33",
                                                            dataIndex: "qty_7",
                                                            key: "qty_7",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "29",
                                                                    dataIndex: "qty_7",
                                                                    key: "qty_7",
                                                                    width: 40,
                                                                    align: "right",
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],

                        }
                    ]
                },
                {
                    title: '"15/16"',
                    dataIndex: "qty_8",
                    key: "qty_8",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "3XL",
                            dataIndex: "qty_8",
                            key: "qty_8",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "6",
                                    dataIndex: "qty_8",
                                    key: "qty_8",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "24W",
                                            dataIndex: "qty_8",
                                            key: "qty_8",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "7x",
                                                    dataIndex: "qty_8",
                                                    key: "qty_8",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "34",
                                                            dataIndex: "qty_8",
                                                            key: "qty_8",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "30",
                                                                    dataIndex: "qty_8",
                                                                    key: "qty_8",
                                                                    width: 40,
                                                                    align: "right",
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }]
                },
                {
                    title: "-",
                    dataIndex: "qty_9",
                    key: "qty_9",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_9",
                            key: "qty_9",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "7",
                                    dataIndex: "qty_9",
                                    key: "qty_9",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "26W",
                                            dataIndex: "qty_9",
                                            key: "qty_9",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "8",
                                                    dataIndex: "qty_9",
                                                    key: "qty_9",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "35",
                                                            dataIndex: "qty_9",
                                                            key: "qty_9",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "31",
                                                                    dataIndex: "qty_9",
                                                                    key: "qty_9",
                                                                    width: 40,
                                                                    align: "right",
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_10",
                    key: "qty_10",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_10",
                            key: "qty_10",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "8",
                                    dataIndex: "qty_10",
                                    key: "qty_10",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "28W",
                                            dataIndex: "qty_10",
                                            key: "qty_10",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "10",
                                                    dataIndex: "qty_10",
                                                    key: "qty_10",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "36",
                                                            dataIndex: "qty_10",
                                                            key: "qty_10",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "32",
                                                                    dataIndex: "qty_10",
                                                                    key: "qty_10",
                                                                    width: 40,
                                                                    align: "right",
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_11",
                    key: "qty_11",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_11",
                            key: "qty_11",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "9",
                                    dataIndex: "qty_11",
                                    key: "qty_11",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "30W",
                                            dataIndex: "qty_11",
                                            key: "qty_11",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "12",
                                                    dataIndex: "qty_11",
                                                    key: "qty_11",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "38",
                                                            dataIndex: "qty_11",
                                                            key: "qty_11",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "33",
                                                                    dataIndex: "qty_11",
                                                                    key: "qty_11",
                                                                    width: 40,
                                                                    align: "right",
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_12",
                    key: "qty_12",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_12",
                            key: "qty_12",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "10",
                                    dataIndex: "qty_12",
                                    key: "qty_12",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "32W",
                                            dataIndex: "qty_12",
                                            key: "qty_12",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "14",
                                                    dataIndex: "qty_12",
                                                    key: "qty_12",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "40",
                                                            dataIndex: "qty_12",
                                                            key: "qty_12",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "34",
                                                                    dataIndex: "qty_12",
                                                                    key: "qty_12",
                                                                    width: 40,
                                                                    align: "right",
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_13",
                    key: "qty_13",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_13",
                            key: "qty_13",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_13",
                                    key: "qty_13",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_13",
                                            key: "qty_13",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "16",
                                                    dataIndex: "qty_13",
                                                    key: "qty_13",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "42",
                                                            dataIndex: "qty_13",
                                                            key: "qty_13",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "35",
                                                                    dataIndex: "qty_13",
                                                                    key: "qty_13",
                                                                    width: 40,
                                                                    align: "right",
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_14",
                    key: "qty_14",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_14",
                            key: "qty_14",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_14",
                                    key: "qty_14",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_14",
                                            key: "qty_14",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "18",
                                                    dataIndex: "qty_14",
                                                    key: "qty_14",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "44",
                                                            dataIndex: "qty_14",
                                                            key: "qty_14",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "36",
                                                                    dataIndex: "qty_14",
                                                                    key: "qty_14",
                                                                    width: 40,
                                                                    align: "right",
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }
                            ]
                        },
                    ],
                },
                {
                    title: "-",
                    dataIndex: "qty_15",
                    key: "qty_15",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_15",
                            key: "qty_15",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_15",
                                    key: "qty_15",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_15",
                                            key: "qty_15",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "20",
                                                    dataIndex: "qty_15",
                                                    key: "qty_15",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "46",
                                                            dataIndex: "qty_15",
                                                            key: "qty_15",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "37",
                                                                    dataIndex: "qty_15",
                                                                    key: "qty_15",
                                                                    width: 40,
                                                                    align: "right",
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_16",
                    key: "qty_16",
                    width: 50,
                    align: "right",
                    // className: "Border-Right-table border-z-index-1",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_16",
                            key: "qty_16",
                            width: 50,
                            align: "right",
                            // className: "Border-Right-table border-z-index-1",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_16",
                                    key: "qty_16",
                                    width: 50,
                                    align: "right",
                                    // className: "Border-Right-table border-z-index-1",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_16",
                                            key: "qty_16",
                                            width: 50,
                                            align: "right",
                                            // className: "Border-Right-table border-z-index-1",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_16",
                                                    key: "qty_16",
                                                    width: 50,
                                                    align: "right",
                                                    // className: "Border-Right-table border-z-index-1",
                                                    children: [
                                                        {
                                                            title: "48",
                                                            dataIndex: "qty_16",
                                                            key: "qty_16",
                                                            width: 50,
                                                            align: "right",
                                                            // className: "Border-Right-table border-z-index-1",
                                                            children: [
                                                                {
                                                                    title: "38",
                                                                    dataIndex: "qty_16",
                                                                    key: "qty_16",
                                                                    width: 40,
                                                                    align: "right",
                                                                    // className: "Border-Right-table border-z-index-1",
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
            ],
        }
    ],
};



export const sizeChartDataNew = {
    columns: [
        {
            children: [
                {
                    title: "T-Jacket",
                    dataIndex: "stage",
                    key: "stage",
                    width: 75,
                    children: [
                        {
                            title: "Shirt",
                            dataIndex: "stage",
                            key: "stage",
                            width: 75,
                            children: [
                                {
                                    title: "Y-Adult",
                                    dataIndex: "stage",
                                    key: "stage",
                                    width: 75,
                                    children: [
                                        {
                                            title: "W-Plus",
                                            dataIndex: "stage",
                                            key: "stage",
                                            width: 75,
                                            children: [
                                                {
                                                    title: "Kids",
                                                    dataIndex: "stage",
                                                    key: "stage",
                                                    width: 75,
                                                    children: [
                                                        {
                                                            title: "Men",
                                                            dataIndex: "stage",
                                                            key: "stage",
                                                            width: 75,
                                                            children: [
                                                                {
                                                                    title: "Women",
                                                                    dataIndex: "stage",
                                                                    key: "stage",
                                                                    width: 80,
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: '"2/3"',
                    align: "right",
                    dataIndex: "qty_1",
                    key: "qty_1",
                    width: 40,
                    children: [
                        {
                            title: "XS",
                            dataIndex: "qty_1",
                            key: "qty_1",
                            width: 40,
                            align: "right",

                            children: [
                                {
                                    title: "00",
                                    dataIndex: "qty_1",
                                    key: "qty_1",
                                    width: 40,
                                    align: "right",
                                    children: [
                                        {
                                            title: "10W",
                                            dataIndex: "qty_1",
                                            key: "qty_1",
                                            width: 40,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "2",
                                                    dataIndex: "qty_1",
                                                    key: "qty_1",
                                                    width: 40,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "27",
                                                            dataIndex: "qty_1",
                                                            key: "qty_1",
                                                            align: "right",
                                                            width: 40,
                                                            children: [
                                                                {
                                                                    title: "23",
                                                                    dataIndex: "qty_1",
                                                                    key: "qty_1",
                                                                    width: 40,
                                                                    align: "right",
                                                                    render: (text) => {
                                                                        if (!text) return null;

                                                                        const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                        const mainValue = parseInt(main);
                                                                        const bracketValue = parseInt(bracket);

                                                                        // Case: 0(0)
                                                                        if (mainValue === 0 && bracketValue === 0) {
                                                                            return "0";
                                                                        }

                                                                        return (
                                                                            <span>
                                                                                {mainValue}
                                                                                {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                    <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                ) : null}
                                                                            </span>
                                                                        );
                                                                    }
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: '"4/5"',
                    align: "right",
                    dataIndex: "qty_2",
                    key: "qty_2",
                    width: 50,
                    children: [
                        {
                            title: "S",
                            align: "right",
                            dataIndex: "qty_2",
                            key: "qty_2",
                            width: 55,

                            children: [
                                {
                                    title: "0",
                                    align: "right",
                                    dataIndex: "qty_2",
                                    key: "qty_2",
                                    width: 55,
                                    children: [
                                        {
                                            title: "12W",
                                            align: "right",
                                            dataIndex: "qty_2",
                                            key: "qty_2",
                                            width: 55,
                                            children: [
                                                {
                                                    title: "3",
                                                    align: "right",
                                                    dataIndex: "qty_2",
                                                    key: "qty_2",
                                                    width: 50,
                                                    children: [
                                                        {
                                                            title: "28",
                                                            align: "right",
                                                            dataIndex: "qty_2",
                                                            key: "qty_2",
                                                            width: 50,
                                                            children: [
                                                                {
                                                                    title: "24",
                                                                    align: "right",
                                                                    dataIndex: "qty_2",
                                                                    key: "qty_2",
                                                                    width: 40,
                                                                    render: (text) => {
                                                                        if (!text) return null;

                                                                        const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                        const mainValue = parseInt(main);
                                                                        const bracketValue = parseInt(bracket);

                                                                        // Case: 0(0)
                                                                        if (mainValue === 0 && bracketValue === 0) {
                                                                            return "0";
                                                                        }

                                                                        return (
                                                                            <span>
                                                                                {mainValue}
                                                                                {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                    <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                ) : null}
                                                                            </span>
                                                                        );
                                                                    }
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: '"6/6X"',
                    dataIndex: "qty_3",
                    key: "qty_3",
                    align: "right",
                    width: 60,
                    children: [
                        {
                            title: "M",
                            dataIndex: "qty_3",
                            key: "qty_3",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "1",
                                    dataIndex: "qty_3",
                                    key: "qty_3",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "14W",
                                            dataIndex: "qty_3",
                                            key: "qty_3",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "4",
                                                    dataIndex: "qty_3",
                                                    key: "qty_3",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "29",
                                                            dataIndex: "qty_3",
                                                            key: "qty_3",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "25",
                                                                    dataIndex: "qty_3",
                                                                    key: "qty_3",
                                                                    width: 45,
                                                                    align: "right",
                                                                    render: (text) => {
                                                                        if (!text) return null;

                                                                        const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                        const mainValue = parseInt(main);
                                                                        const bracketValue = parseInt(bracket);

                                                                        // Case: 0(0)
                                                                        if (mainValue === 0 && bracketValue === 0) {
                                                                            return "0";
                                                                        }

                                                                        return (
                                                                            <span>
                                                                                {mainValue}
                                                                                {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                    <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                ) : null}
                                                                            </span>
                                                                        );
                                                                    }
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],

                        }
                    ]
                },
                {
                    title: '"7/8"',
                    dataIndex: "qty_4",
                    key: "qty_4",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "L",
                            dataIndex: "qty_4",
                            key: "qty_4",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "2",
                                    dataIndex: "qty_4",
                                    key: "qty_4",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "16W",
                                            dataIndex: "qty_4",
                                            key: "qty_4",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "5",
                                                    dataIndex: "qty_4",
                                                    key: "qty_4",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "30",
                                                            dataIndex: "qty_4",
                                                            key: "qty_4",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "26",
                                                                    dataIndex: "qty_4",
                                                                    key: "qty_4",
                                                                    width: 40,
                                                                    align: "right",
                                                                    render: (text) => {
                                                                        if (!text) return null;

                                                                        const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                        const mainValue = parseInt(main);
                                                                        const bracketValue = parseInt(bracket);

                                                                        // Case: 0(0)
                                                                        if (mainValue === 0 && bracketValue === 0) {
                                                                            return "0";
                                                                        }

                                                                        return (
                                                                            <span>
                                                                                {mainValue}
                                                                                {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                    <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                ) : null}
                                                                            </span>
                                                                        );
                                                                    }
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: '"9/10"',
                    dataIndex: "qty_5",
                    key: "qty_5",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "XL",
                            dataIndex: "qty_5",
                            key: "qty_5",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "3",
                                    dataIndex: "qty_5",
                                    key: "qty_5",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "18W",
                                            dataIndex: "qty_5",
                                            key: "qty_5",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "6",
                                                    dataIndex: "qty_5",
                                                    key: "qty_5",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "31",
                                                            dataIndex: "qty_5",
                                                            key: "qty_5",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "27",
                                                                    dataIndex: "qty_5",
                                                                    key: "qty_5",
                                                                    width: 40,
                                                                    align: "right",
                                                                    render: (text) => {
                                                                        if (!text) return null;

                                                                        const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                        const mainValue = parseInt(main);
                                                                        const bracketValue = parseInt(bracket);

                                                                        // Case: 0(0)
                                                                        if (mainValue === 0 && bracketValue === 0) {
                                                                            return "0";
                                                                        }

                                                                        return (
                                                                            <span>
                                                                                {mainValue}
                                                                                {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                    <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                ) : null}
                                                                            </span>
                                                                        );
                                                                    }
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: '"11/12"',
                    dataIndex: "qty_6",
                    key: "qty_6",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "XXL / 1XL",
                            dataIndex: "qty_6",
                            key: "qty_6",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "4",
                                    dataIndex: "qty_6",
                                    key: "qty_6",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "20W",
                                            dataIndex: "qty_6",
                                            key: "qty_6",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "6x",
                                                    dataIndex: "qty_6",
                                                    key: "qty_6",
                                                    width: 50,
                                                    align: "right",

                                                    children: [
                                                        {
                                                            title: "32",
                                                            dataIndex: "qty_6",
                                                            key: "qty_6",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "28",
                                                                    dataIndex: "qty_6",
                                                                    key: "qty_6",
                                                                    width: 40,
                                                                    align: "right",
                                                                    render: (text) => {
                                                                        if (!text) return null;

                                                                        const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                        const mainValue = parseInt(main);
                                                                        const bracketValue = parseInt(bracket);

                                                                        // Case: 0(0)
                                                                        if (mainValue === 0 && bracketValue === 0) {
                                                                            return "0";
                                                                        }

                                                                        return (
                                                                            <span>
                                                                                {mainValue}
                                                                                {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                    <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                ) : null}
                                                                            </span>
                                                                        );
                                                                    }
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],

                        }
                    ]
                },
                {
                    title: '"13/14"',
                    dataIndex: "qty_7",
                    key: "qty_7",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "2XL",
                            dataIndex: "qty_7",
                            key: "qty_7",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "5",
                                    dataIndex: "qty_7",
                                    key: "qty_7",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "22W",
                                            dataIndex: "qty_7",
                                            key: "qty_7",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "7",
                                                    dataIndex: "qty_7",
                                                    key: "qty_7",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "33",
                                                            dataIndex: "qty_7",
                                                            key: "qty_7",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "29",
                                                                    dataIndex: "qty_7",
                                                                    key: "qty_7",
                                                                    width: 40,
                                                                    align: "right",
                                                                    render: (text) => {
                                                                        if (!text) return null;

                                                                        const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                        const mainValue = parseInt(main);
                                                                        const bracketValue = parseInt(bracket);

                                                                        // Case: 0(0)
                                                                        if (mainValue === 0 && bracketValue === 0) {
                                                                            return "0";
                                                                        }

                                                                        return (
                                                                            <span>
                                                                                {mainValue}
                                                                                {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                    <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                ) : null}
                                                                            </span>
                                                                        );
                                                                    }
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],

                        }
                    ]
                },
                {
                    title: '"15/16"',
                    dataIndex: "qty_8",
                    key: "qty_8",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "3XL",
                            dataIndex: "qty_8",
                            key: "qty_8",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "6",
                                    dataIndex: "qty_8",
                                    key: "qty_8",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "24W",
                                            dataIndex: "qty_8",
                                            key: "qty_8",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "7x",
                                                    dataIndex: "qty_8",
                                                    key: "qty_8",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "34",
                                                            dataIndex: "qty_8",
                                                            key: "qty_8",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "30",
                                                                    dataIndex: "qty_8",
                                                                    key: "qty_8",
                                                                    width: 40,
                                                                    align: "right",
                                                                    render: (text) => {
                                                                        if (!text) return null;

                                                                        const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                        const mainValue = parseInt(main);
                                                                        const bracketValue = parseInt(bracket);

                                                                        // Case: 0(0)
                                                                        if (mainValue === 0 && bracketValue === 0) {
                                                                            return "0";
                                                                        }

                                                                        return (
                                                                            <span>
                                                                                {mainValue}
                                                                                {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                    <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                ) : null}
                                                                            </span>
                                                                        );
                                                                    }
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }]
                },
                {
                    title: "-",
                    dataIndex: "qty_9",
                    key: "qty_9",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_9",
                            key: "qty_9",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "7",
                                    dataIndex: "qty_9",
                                    key: "qty_9",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "26W",
                                            dataIndex: "qty_9",
                                            key: "qty_9",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "8",
                                                    dataIndex: "qty_9",
                                                    key: "qty_9",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "35",
                                                            dataIndex: "qty_9",
                                                            key: "qty_9",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "31",
                                                                    dataIndex: "qty_9",
                                                                    key: "qty_9",
                                                                    width: 40,
                                                                    align: "right",
                                                                    render: (text) => {
                                                                        if (!text) return null;

                                                                        const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                        const mainValue = parseInt(main);
                                                                        const bracketValue = parseInt(bracket);

                                                                        // Case: 0(0)
                                                                        if (mainValue === 0 && bracketValue === 0) {
                                                                            return "0";
                                                                        }

                                                                        return (
                                                                            <span>
                                                                                {mainValue}
                                                                                {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                    <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                ) : null}
                                                                            </span>
                                                                        );
                                                                    }
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_10",
                    key: "qty_10",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_10",
                            key: "qty_10",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "8",
                                    dataIndex: "qty_10",
                                    key: "qty_10",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "28W",
                                            dataIndex: "qty_10",
                                            key: "qty_10",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "10",
                                                    dataIndex: "qty_10",
                                                    key: "qty_10",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "36",
                                                            dataIndex: "qty_10",
                                                            key: "qty_10",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "32",
                                                                    dataIndex: "qty_10",
                                                                    key: "qty_10",
                                                                    width: 40,
                                                                    align: "right",
                                                                    render: (text) => {
                                                                        if (!text) return null;

                                                                        const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                        const mainValue = parseInt(main);
                                                                        const bracketValue = parseInt(bracket);

                                                                        // Case: 0(0)
                                                                        if (mainValue === 0 && bracketValue === 0) {
                                                                            return "0";
                                                                        }

                                                                        return (
                                                                            <span>
                                                                                {mainValue}
                                                                                {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                    <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                ) : null}
                                                                            </span>
                                                                        );
                                                                    }
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_11",
                    key: "qty_11",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_11",
                            key: "qty_11",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "9",
                                    dataIndex: "qty_11",
                                    key: "qty_11",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "30W",
                                            dataIndex: "qty_11",
                                            key: "qty_11",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "12",
                                                    dataIndex: "qty_11",
                                                    key: "qty_11",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "38",
                                                            dataIndex: "qty_11",
                                                            key: "qty_11",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "33",
                                                                    dataIndex: "qty_11",
                                                                    key: "qty_11",
                                                                    width: 40,
                                                                    align: "right",
                                                                    render: (text) => {
                                                                        if (!text) return null;

                                                                        const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                        const mainValue = parseInt(main);
                                                                        const bracketValue = parseInt(bracket);

                                                                        // Case: 0(0)
                                                                        if (mainValue === 0 && bracketValue === 0) {
                                                                            return "0";
                                                                        }

                                                                        return (
                                                                            <span>
                                                                                {mainValue}
                                                                                {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                    <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                ) : null}
                                                                            </span>
                                                                        );
                                                                    }
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_12",
                    key: "qty_12",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_12",
                            key: "qty_12",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "10",
                                    dataIndex: "qty_12",
                                    key: "qty_12",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "32W",
                                            dataIndex: "qty_12",
                                            key: "qty_12",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "14",
                                                    dataIndex: "qty_12",
                                                    key: "qty_12",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "40",
                                                            dataIndex: "qty_12",
                                                            key: "qty_12",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "34",
                                                                    dataIndex: "qty_12",
                                                                    key: "qty_12",
                                                                    width: 40,
                                                                    align: "right",
                                                                    render: (text) => {
                                                                        if (!text) return null;

                                                                        const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                        const mainValue = parseInt(main);
                                                                        const bracketValue = parseInt(bracket);

                                                                        // Case: 0(0)
                                                                        if (mainValue === 0 && bracketValue === 0) {
                                                                            return "0";
                                                                        }

                                                                        return (
                                                                            <span>
                                                                                {mainValue}
                                                                                {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                    <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                ) : null}
                                                                            </span>
                                                                        );
                                                                    }
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_13",
                    key: "qty_13",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_13",
                            key: "qty_13",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_13",
                                    key: "qty_13",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_13",
                                            key: "qty_13",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "16",
                                                    dataIndex: "qty_13",
                                                    key: "qty_13",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "42",
                                                            dataIndex: "qty_13",
                                                            key: "qty_13",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "35",
                                                                    dataIndex: "qty_13",
                                                                    key: "qty_13",
                                                                    width: 40,
                                                                    align: "right",
                                                                    render: (text) => {
                                                                        if (!text) return null;

                                                                        const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                        const mainValue = parseInt(main);
                                                                        const bracketValue = parseInt(bracket);

                                                                        // Case: 0(0)
                                                                        if (mainValue === 0 && bracketValue === 0) {
                                                                            return "0";
                                                                        }

                                                                        return (
                                                                            <span>
                                                                                {mainValue}
                                                                                {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                    <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                ) : null}
                                                                            </span>
                                                                        );
                                                                    }
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_14",
                    key: "qty_14",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_14",
                            key: "qty_14",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_14",
                                    key: "qty_14",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_14",
                                            key: "qty_14",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "18",
                                                    dataIndex: "qty_14",
                                                    key: "qty_14",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "44",
                                                            dataIndex: "qty_14",
                                                            key: "qty_14",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "36",
                                                                    dataIndex: "qty_14",
                                                                    key: "qty_14",
                                                                    width: 40,
                                                                    align: "right",
                                                                    render: (text) => {
                                                                        if (!text) return null;

                                                                        const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                        const mainValue = parseInt(main);
                                                                        const bracketValue = parseInt(bracket);

                                                                        // Case: 0(0)
                                                                        if (mainValue === 0 && bracketValue === 0) {
                                                                            return "0";
                                                                        }

                                                                        return (
                                                                            <span>
                                                                                {mainValue}
                                                                                {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                    <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                ) : null}
                                                                            </span>
                                                                        );
                                                                    }
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }
                            ]
                        },
                    ],
                },
                {
                    title: "-",
                    dataIndex: "qty_15",
                    key: "qty_15",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_15",
                            key: "qty_15",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_15",
                                    key: "qty_15",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_15",
                                            key: "qty_15",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "20",
                                                    dataIndex: "qty_15",
                                                    key: "qty_15",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "46",
                                                            dataIndex: "qty_15",
                                                            key: "qty_15",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "37",
                                                                    dataIndex: "qty_15",
                                                                    key: "qty_15",
                                                                    width: 40,
                                                                    align: "right",
                                                                    render: (text) => {
                                                                        if (!text) return null;

                                                                        const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                        const mainValue = parseInt(main);
                                                                        const bracketValue = parseInt(bracket);

                                                                        // Case: 0(0)
                                                                        if (mainValue === 0 && bracketValue === 0) {
                                                                            return "0";
                                                                        }

                                                                        return (
                                                                            <span>
                                                                                {mainValue}
                                                                                {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                    <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                ) : null}
                                                                            </span>
                                                                        );
                                                                    }
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_16",
                    key: "qty_16",
                    width: 50,
                    align: "right",
                    // className: "Border-Right-table border-z-index-1",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_16",
                            key: "qty_16",
                            width: 50,
                            align: "right",
                            // className: "Border-Right-table border-z-index-1",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_16",
                                    key: "qty_16",
                                    width: 50,
                                    align: "right",
                                    // className: "Border-Right-table border-z-index-1",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_16",
                                            key: "qty_16",
                                            width: 50,
                                            align: "right",
                                            // className: "Border-Right-table border-z-index-1",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_16",
                                                    key: "qty_16",
                                                    width: 50,
                                                    align: "right",
                                                    // className: "Border-Right-table border-z-index-1",
                                                    children: [
                                                        {
                                                            title: "48",
                                                            dataIndex: "qty_16",
                                                            key: "qty_16",
                                                            width: 50,
                                                            align: "right",
                                                            // className: "Border-Right-table border-z-index-1",
                                                            children: [
                                                                {
                                                                    title: "38",
                                                                    dataIndex: "qty_16",
                                                                    key: "qty_16",
                                                                    width: 40,
                                                                    align: "right",
                                                                    // className: "Border-Right-table border-z-index-1",
                                                                    render: (text) => {
                                                                        if (!text) return null;

                                                                        const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                        const mainValue = parseInt(main);
                                                                        const bracketValue = parseInt(bracket);

                                                                        // Case: 0(0)
                                                                        if (mainValue === 0 && bracketValue === 0) {
                                                                            return "0";
                                                                        }

                                                                        return (
                                                                            <span>
                                                                                {mainValue}
                                                                                {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                    <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                ) : null}
                                                                            </span>
                                                                        );
                                                                    }
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                },
                            ],
                        }
                    ]
                },
            ],
        }
    ],
};